module.exports = __webpack_public_path__ + "static/media/okr2.58ebdb53.png";